import { Controller } from "@hotwired/stimulus"

export default class ActivityPreviewController extends Controller {
  static targets = ["previewWrapper", "contentWrapper", "richTextEditorWrapper"]

  expandContent() {
    this.#hidePreviewWrapper()
    this.#showContentWrapper()
    this.#hideRichTextEditor()
  }

  collapseContent() {
    this.#showPreviewWrapper()
    this.#hideContentWrapper()
    this.#hideRichTextEditor()
  }

  editContent() {
    this.#hidePreviewWrapper()
    this.#hideContentWrapper()
    this.#showRichTextEditor()
  }

  #showPreviewWrapper() {
    if (this.hasPreviewWrapperTarget) {
      this.previewWrapperTarget.classList.remove("hidden")
    }
  }

  #hidePreviewWrapper() {
    if (this.hasPreviewWrapperTarget) {
      this.previewWrapperTarget.classList.add("hidden")
    }
  }

  #showContentWrapper() {
    if (this.hasContentWrapperTarget) {
      this.contentWrapperTarget.classList.remove("hidden")
    }
  }

  #hideContentWrapper() {
    if (this.hasContentWrapperTarget) {
      this.contentWrapperTarget.classList.add("hidden")
    }
  }

  #showRichTextEditor() {
    if (this.hasRichTextEditorWrapperTarget) {
      this.richTextEditorWrapperTarget.classList.remove("hidden")
    }
  }

  #hideRichTextEditor() {
    if (this.hasRichTextEditorWrapperTarget) {
      this.richTextEditorWrapperTarget.classList.add("hidden")
    }
  }
}
